import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function Reviews() {
  const { t } = useLang();

  const REVIEWS = [
    { text: t("rev1_text"), name: t("rev1_name"), meta: t("rev1_meta") },
    { text: t("rev2_text"), name: t("rev2_name"), meta: t("rev2_meta") },
    { text: t("rev3_text"), name: t("rev3_name"), meta: t("rev3_meta") },
  ];

  return (
    <section
      id="reviews"
      className="py-16 sm:py-24 lg:py-32 bg-[#0E1A2B] grain relative overflow-hidden"
      data-testid="reviews-section"
    >
      <div className="absolute -bottom-24 right-1/4 h-96 w-96 rounded-full bg-[#F26522]/10 blur-3xl pointer-events-none" />
      <div className="relative px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-14"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#F26522] font-semibold mb-4">
            {t("rev_eyebrow")}
          </p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            {t("rev_h")}
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-300">
            {t("rev_sub")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {REVIEWS.map((r, idx) => (
            <motion.blockquote
              key={r.name}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: idx * 0.12 }}
              whileHover={{ y: -6 }}
              className="relative rounded-3xl bg-[#132338] border border-[#203859] p-6 sm:p-8 transition-shadow duration-300 hover:shadow-2xl"
              data-testid={`review-card-${idx}`}
            >
              <Quote className="h-8 w-8 text-[#F26522]/40" />
              <div className="mt-4 flex gap-1" aria-label="5 out of 5 stars">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="h-4 w-4 fill-[#F26522] text-[#F26522]" />
                ))}
              </div>
              <p className="mt-4 text-base leading-relaxed text-slate-200">
                "{r.text}"
              </p>
              <footer className="mt-6 border-t border-white/10 pt-4">
                <p className="font-display font-bold text-white">{r.name}</p>
                <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-400">
                  {r.meta}
                </p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
